import { getRandomElement, getRandomInt } from '../utils/randomUtils';
import type { UserPet } from '../types/pets';
import type { UserItem } from '../types/items';

// AI opponent templates with proper image URLs
const AI_OPPONENTS = [
  {
    id: 'ai-galahad',
    name: 'Sir Galahad',
    title: 'The Pure',
    strategy: 'balanced',
    wagerRange: [1000, 5000],
    pets: [
      {
        name: 'Royal Griffin',
        type: 'griffin',
        rarity: 'rare',
        imageUrl: 'https://i.ibb.co/vwBt9zt/mountain-griffin.jpg',
        stats: { strength: 25, agility: 30, vitality: 22, intelligence: 28 }
      },
      {
        name: 'Noble Unicorn',
        type: 'unicorn',
        rarity: 'rare',
        imageUrl: 'https://i.ibb.co/Tq8Vhwj/silver-unicorn.jpg',
        stats: { strength: 22, agility: 25, vitality: 30, intelligence: 28 }
      }
    ],
    items: []
  },
  {
    id: 'ai-morgana',
    name: 'Lady Morgana',
    title: 'The Enchantress',
    strategy: 'aggressive',
    wagerRange: [5000, 15000],
    pets: [
      {
        name: 'Shadow Dragon',
        type: 'dragon',
        rarity: 'epic',
        imageUrl: 'https://i.ibb.co/xDgFDQM/shadow-dragon.jpg',
        stats: { strength: 35, agility: 25, vitality: 28, intelligence: 32 }
      },
      {
        name: 'Flame Phoenix',
        type: 'phoenix',
        rarity: 'epic',
        imageUrl: 'https://i.ibb.co/JcqMN9W/flame-phoenix.jpg',
        stats: { strength: 30, agility: 35, vitality: 25, intelligence: 35 }
      }
    ],
    items: []
  },
  {
    id: 'ai-merlin',
    name: 'Merlin',
    title: 'The Wise',
    strategy: 'defensive',
    wagerRange: [15000, 30000],
    pets: [
      {
        name: 'Forest Wolf',
        type: 'wolf',
        rarity: 'legendary',
        imageUrl: 'https://i.ibb.co/DV1fxT0/forest-wolf.jpg',
        stats: { strength: 40, agility: 35, vitality: 45, intelligence: 50 }
      }
    ],
    items: []
  }
];

class AiOpponentsService {
  findOpponent(wagerAmount: number): {
    name: string;
    title: string;
    strategy: string;
    pets: UserPet[];
    items: UserItem[];
  } | null {
    // Find all AI opponents that match the wager range
    const eligibleOpponents = AI_OPPONENTS.filter(
      ai => wagerAmount >= ai.wagerRange[0] && wagerAmount <= ai.wagerRange[1]
    );

    if (eligibleOpponents.length === 0) return null;

    // Randomly select one of the eligible opponents
    const opponent = getRandomElement(eligibleOpponents);

    // Map pets to include required UserPet properties
    const pets = opponent.pets.map(pet => ({
      id: crypto.randomUUID(),
      name: pet.name,
      type: pet.type,
      rarity: pet.rarity,
      imageUrl: pet.imageUrl,
      stats: pet.stats,
      level: getRandomInt(5, 15),
      experience: 0,
      equippedItems: [],
      createdAt: new Date().toISOString()
    }));

    return {
      name: opponent.name,
      title: opponent.title,
      strategy: opponent.strategy,
      pets,
      items: opponent.items
    };
  }
}

export const aiOpponentsService = new AiOpponentsService();